import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../../shared/shared-imports';
import { customValidator } from '../../../../Utils/validator';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { Utils } from '../../../../Utils/utils';
import { DocumentServiceType, FieldValue, ServiceName, ServiceNameAr, ServiceNameEn, SrActionType, SrIOName, UserType } from '../../../../shared/constants/services.enum';
import { environment } from '../../../../../environments/environment';
import { OptionFieldComponent } from '../../../../shared/components/controls/option-field/option-field.component';
import { TextFieldComponent } from '../../../../shared/components/controls/text-field/text-field.component';
import { LookupKey } from '../../../../shared/constants/lookup-keys';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { ApiService } from '../../../../core/services/api.service';
import { AddCarnetProductComponent } from "./add-carnet-product/add-carnet-product.component";
import { IssueAtaCarnetRequest } from '../../../../shared/models/services-request/issue-ata-carnet.model';
import { SharedService } from '../../../../shared/services/shared.service';
import { SrSubmitSuccessModalComponent } from "../../../../shared/components/sr-submit-success-modal/sr-submit-success-modal.component";
import { SrStatus } from '../../../../shared/constants/status.enum';
import { Product } from '../../../../shared/models/product.model';
import { SkeletonLoaderComponent } from "../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { OPEN_TRAVEL_PLANS, OPEN_TRAVEL_PLANS_AR } from './models/open-carnet-travelplan.model';
import { SecurityDepositRequest } from './models/security-deposit-request.model';
import { GetCarnetNoRequest } from './models/get-ata-carnet-request.model';
import { CopyCarnetSrRequest } from './models/copy-carnet-request.model';
import { CarnetQueryRequest } from './models/carnet-query.model';
import { AtaReplaceSRRequest } from '../../../../shared/models/services-request/ata-replace.model';
import { CardCarouselComponent } from "../../../../shared/components/card-carousel/card-carousel.component";
import { BranchLocation, CarnetTypes } from './models/carnet-types.model';
import { FolderResponse, AllowedDocumentType } from '../../../../shared/models/documents-response.model';
import { FileComponent } from '../../../../shared/components/controls/file/file.component';
import { TextFieldComponent as TFC } from '../../../../shared/components/controls/text-field/text-field.component';
import { OptionFieldComponent as OFC } from '../../../../shared/components/controls/option-field/option-field.component';
import { HSCodeRequest } from '../../../../shared/models/hs-code-request.model';
import { lastValueFrom } from 'rxjs';
import { DateComponent } from '../../../../shared/components/controls/date/date.component';
import { MobileNumberComponent } from '../../../../shared/components/controls/mobile-number/mobile-number.component';
import { OptionTranslateService } from '../../../../shared/services/option-translate.service';
import { DigitalConsentModalComponent } from "./digital-consent-modal/digital-consent-modal.component";
import { CurrencyPipe } from '../../../../shared/pipes/currency.pipe';

@Component({
  selector: 'app-ata-carnet',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS,
    AddCarnetProductComponent, SrSubmitSuccessModalComponent, SkeletonLoaderComponent, CardCarouselComponent, DigitalConsentModalComponent, CurrencyPipe],
  templateUrl: './ata-carnet.component.html',
  styleUrl: './ata-carnet.component.scss'
})
export class AtaCarnetComponent implements OnInit, OnDestroy {
  @ViewChildren('fileCmp') fileComponents!: QueryList<FileComponent>;
  @ViewChildren(TextFieldComponent) textFields!: QueryList<TextFieldComponent>;
  @ViewChildren(OptionFieldComponent) optionFields!: QueryList<OptionFieldComponent>;
  @ViewChildren(DateComponent) dateFields!: QueryList<DateComponent>;
  @ViewChildren(MobileNumberComponent) mobileFields!: QueryList<MobileNumberComponent>;

  request: IssueAtaCarnetRequest = new IssueAtaCarnetRequest();
  securityDepositRequest: SecurityDepositRequest = new SecurityDepositRequest();
  hsCodeRequest: HSCodeRequest = new HSCodeRequest();

  lookupKey = LookupKey;
  userType = UserType;
  fieldValue = FieldValue;
  documentServiceType = DocumentServiceType;
  servicePath: 'new' | 'amendment' | 'substitute' | 'replace' = 'new';
  allFields: any = [];
  form: FormGroup;
  step: any = 1;
  totalSteps: any = 7;
  countries: any = [];
  addProductModal: boolean = false;
  viewProductModal: boolean = false;
  counterfoilsAmount: any = 5;
  products: Product[] = [];
  addJourney: boolean = true;
  journeyList: any = [];
  typesOfCarnet = CarnetTypes;
  editJourneyDetail: any | null = null;

  userLoginName: string = "";
  userCSN: any = "";
  srNumber: any = "";
  lang: any = "";

  loginUserDetail: any = "";
  srType: string = "";
  srSubType: string = "";
  canAddEdit: boolean = true;
  invalidSummary: string[] = [];
  serviceTitle: string = "ATA_CARNET.NEW_SERVICE";
  standardOption: any = [];
  selectedMember: any = "";
  availabelDepositAmount: any = 0;
  loadingDoc: boolean = false;

  srInprgoressAwating: boolean = false;
  showNotes: boolean = false;
  // This method is used to initialize the class instance using fb, router, route, api, shared service, and option translate service
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private sharedService: SharedService,
    private optionTranslateService: OptionTranslateService
  ) {
    this.lang = this.sharedService.getCurrentLang();
    this.loginUserDetail = this.sharedService.getUserProfile();
    this.userLoginName = this.sharedService.getUserProfile()['Login Name'];
    this.userCSN = this.sharedService.getCsnAccountId('csn');
    this.selectedMember = this.sharedService.getPrimaryAccount();
    this.getApplicantType();
    this.standardOption = this.optionTranslateService.getOptions(
      'standardOption',
      this.lang
    );
    this.route.data.subscribe(data => {
      this.servicePath = data['mode'];
      if (this.servicePath === 'new') {
        this.step = 2;
      }
    });
    this.srType = ServiceName.ATA_CARNET;
    this.srSubType = ServiceName.ISSUE_NEW_CARNET;
    if (this.isAmendmentCarnet) {
      this.srSubType = ServiceName.AMENDMENT_CARNET;
      this.serviceTitle = "ATA_CARNET.APPLY_FOR_AMEND";
    }
    if (this.isReplaceCarnet) {
      this.srSubType = ServiceName.REPLACE_CARNET;
      this.serviceTitle = "ATA_CARNET.APPLY_FOR_REPLACE";
      this.canAddEdit = false;
    }
    if (this.isSubstituteCarnet) {
      this.srSubType = ServiceName.SUBSTITUTE_CARNET;
      this.serviceTitle = "ATA_CARNET.APPLY_FOR_SUBSTITUTE";
      this.canAddEdit = false;
    }


    this.form = this.fb.group({
      carnetNumber: "",
      holderType: [''],
      contact: this.fb.group({
        fullName: ['', [Validators.required, Validators.maxLength(30), customValidator('english')]],
        email: ['', [Validators.required, Validators.maxLength(100), customValidator('email')]],
        mobile: ['', [Validators.required, Validators.maxLength(40), customValidator('uaeMobile')]],
        countryCode: [null],
        phone: ['', [Validators.required, Validators.maxLength(40), customValidator('mobile')]]
      }),
      hasOtherEmirateLicense: [''],
      otherEmirateName: [''],
      // representative: this.fb.group({
      //   fullName: ['', [Validators.maxLength(100), customValidator('english')]],
      //   email: ['', [Validators.maxLength(100), customValidator('email')]],
      //   mobile: ['', [Validators.maxLength(40), customValidator('uaeMobile')]],
      //   countryCode: [null],
      //   phone: ['', [Validators.maxLength(40), customValidator('mobile')]]
      // }),
      // company: this.fb.group({
      //   name: ['', [Validators.maxLength(100), customValidator('english')]],
      //   mobile: ['', [Validators.maxLength(40), customValidator('uaeMobile')]],
      //   countryCode: [null],
      //   phone: ['', [Validators.maxLength(40), customValidator('mobile')]],
      //   hasOtherEmirateLicense: [''],
      //   otherEmirateName: ['']
      // }),
      cargo: this.fb.group({
        purpose: ['', Validators.required],
        currency: ['', Validators.required]
      }),
      products: ['', [Validators.required]],
      carnetType: ['', [Validators.required]],
      journeyDetails: [''],
      journeyDestination: [''],
      journeyEntryType: [''],
      journeyTransportMode: [''],
      journeyAddCounterfoils: [''],
      counterfoils: [''],
      processingType: [''],
      collectionType: ['', Validators.required],
      agree: [false, Validators.requiredTrue],
      courier: this.fb.group({
        countryCode: [null],
        mobile: ['', [Validators.maxLength(40), customValidator('uaeMobile')]],
        email: ['', [customValidator('email'), Validators.maxLength(100)]],
        buildingUnit: ['', [Validators.maxLength(200)]],
        address: ['', [Validators.maxLength(500), customValidator('safeText')]],
        area: ['', [Validators.maxLength(100), customValidator('safeText')]],
        emirate: [null, [Validators.maxLength(50)]]
      }),
      substituteReason: ['', [Validators.maxLength(500), customValidator('safeText')]],
      visitCounterfoil: ['0', [customValidator('numberOnly')]],
      transitCounterfoil: ['0', [customValidator('numberOnly')]],
      paymentMethod: [null, [Validators.required]],
      companNameEng: ['', [Validators.maxLength(100), customValidator('english')]],
      companNameAra: ['', [Validators.maxLength(100), customValidator('arabic')]],
    });


    // SR Number in the url
    const routeSrNumber = this.route.snapshot.params?.['sr_no'];
    const routeCsn = this.route.snapshot.params?.['csn'];
    if (routeCsn) {
      this.userCSN = routeCsn;
    }
    if (routeSrNumber) {
      this.srNumber = routeSrNumber;
    }
    // in case of draft
    if (sessionStorage.getItem("srNumber") && this.srNumber == "") {
      let storeSrNumber: any = sessionStorage.getItem("srNumber");
      this.srNumber = storeSrNumber ? storeSrNumber : "";
    }

    this.route.params.subscribe(params => {
      const srNo = params['sr_no'];
      const csn = params['csn'];
      if (csn) {
        this.userCSN = csn;
      }
      if (srNo && srNo !== this.srNumber) {
        this.srNumber = srNo;
        this.getSRDetail();
      }
    });

    if (this.srNumber) {
      this.getSRDetail();
    }

    if (!this.userCSN && !this.srNumber) {
      this.sharedService.toastMessage('INFO', 'NO_CSN_NUMBER', 'info');
      this.router.navigate([RoutesPath.DASHBOARD]);
      return;
    }
    if (!this.srNumber) {
      this.setDefaultValueForMember();
      this.openFolder();
    }
    // this.onHolderTypeChange('Myself');

    this.getCurrencyList();
  }
  // This method is used to get invalid field labels
  getInvalidFieldLabels(): string[] {
    const labels: string[] = [];
    // This method is used to make array using q
    const makeArray = <T>(q: QueryList<T> | undefined) => (q ? q.toArray() : []);
    const fields = [...makeArray<TFC>(this.textFields), ...makeArray<OFC>(this.optionFields)];
    fields.forEach((cmp: any) => {
      const ctrl = cmp?.control;
      const label = cmp?.label;
      if (!ctrl) return;
      const invalid = ctrl.invalid && (ctrl.touched || ctrl.dirty || this.isFromSumit);
      if (invalid && label && !labels.includes(label)) {
        labels.push(label);
      }
    });
    return labels;
  }
  // This method is used to g using path
  g = (path: string) => this.form.get(path)!;

  // This method is used to calculate form progress
  get formProgress() {
    if (this.form.disabled) {
      return 100;
    }
    if (!this.form.invalid) {
      if (!this.checkRequiredDocuments()) {
        return 100;
      }
    }
    return Utils.calculateFormProgress(this.step, this.totalSteps);
  }

  // This method is used to check if new carnet
  get isNewCarnet(): boolean {
    return this.servicePath === 'new';
  }
  // This method is used to check if amendment carnet
  get isAmendmentCarnet(): boolean {
    return this.servicePath === 'amendment'
  }
  // This method is used to check if substitute carnet
  get isSubstituteCarnet(): boolean {
    return this.servicePath === 'substitute';
  }
  // This method is used to check if replace carnet
  get isReplaceCarnet(): boolean {
    return this.servicePath === 'replace';
  }
  locationContent = BranchLocation;

  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    if (!this.isNewCarnet) {
      this.toggleRequired(true, ["carnetNumber"]);
      if (!this.srNumber && this.userCSN) {
        this.getATACarnetList();
      }
    }
    if (this.isSubstituteCarnet) {
      this.toggleRequired(true, ["substituteReason"]);
    }
    if (this.isSubstituteCarnet) {
      this.toggleRequired(true, ["substituteReason"]);
    }
    if (this.isNewCarnet) {
      this.toggleRequired(true, ["processingType"]);
    }
    if (this.selectedMember?.['Account Type Code'] != UserType.MEMBER) {
      this.toggleRequired(true, ['companNameEng', 'companNameAra']);
    }
    // Call the function to disbale fields;
    Utils.disableFieldsForReplace(this.srSubType, this.form);
    this.getMasterHsCode();
  }

  setDefaultValueForMember() {
    if (this.loginUserDetail && this.selectedMember?.['Account Type Code'] != UserType.MEMBER && this.isNewCarnet) {
      this.form.get("contact.fullName")?.setValue(this.loginUserDetail['Name English'] ? this.loginUserDetail['Name English'] : `${this.loginUserDetail['First Name']}`);
      this.form.get("contact.email")?.setValue(this.loginUserDetail['EMail Addr']);
      this.form.get("contact.mobile")?.setValue(this.loginUserDetail['Phone #'] ? Utils.parseMobile(this.loginUserDetail['Phone #'], 'number') : '');
      this.form.get("contact.countryCode")?.setValue(this.loginUserDetail['Phone #'] ? Utils.parseMobile(this.loginUserDetail['Phone #'], 'cc') : '971');
    } else {
      if (this.selectedMember?.['Account Type Code'] == UserType.MEMBER && this.isNewCarnet) {
        this.form.get("contact.fullName")?.setValue(this.selectedMember['DC Name English'] ?? '');
        this.form.get("contact.email")?.setValue(this.selectedMember['Main Email Address'] ?? '');
        this.form.get("contact.mobile")?.setValue(this.selectedMember['Main Phone Number'] ? Utils.parseMobile(this.selectedMember['Main Phone Number'], 'number') : '');
      }
    }
    this.form.patchValue({
      contact: { countryCode: '971' },
      courier: { countryCode: '971' }
    });
    this.form.get('contact.countryCode')?.disable();
    this.form.get('courier.countryCode')?.disable();
  }
  // This method is used to handle holder type change event using value
  // onHolderTypeChange(value: any) {
  //   let companyFields = ['company.name', 'company.mobile', 'company.phone', 'company.countryCode',
  //     'representative.fullName', 'representative.email', 'representative.mobile', 'representative.countryCode', 'representative.phone'
  //   ];
  //   let contactFields = [
  //     'contact.fullName', 'contact.email', 'contact.mobile', 'contact.countryCode', 'contact.phone'
  //   ];
  //   this.toggleRequired(value == "Other" ? true : false, companyFields);
  //   this.toggleRequired(value != "Other" ? true : false, contactFields);

  //   if (value != "Other" && this.loginUserDetail) {
  //     this.form.get("contact.fullName")?.setValue(`${this.loginUserDetail['First Name']} ${this.loginUserDetail['Last Name']}`);
  //     this.form.get("contact.email")?.setValue(this.loginUserDetail['EMail Addr']);
  //     this.form.get("contact.mobile")?.setValue(this.loginUserDetail['Phone #'] ? Utils.parseMobile(this.loginUserDetail['Phone #'], 'number') : '');
  //     this.form.get("contact.countryCode")?.setValue(this.loginUserDetail['Phone #'] ? Utils.parseMobile(this.loginUserDetail['Phone #'], 'cc') : '971');
  //   } else {
  //     if (this.selectedMember?.['Account Type Code'] == UserType.MEMBER) {
  //       this.form.get("company.name")?.disable();
  //       this.form.get("company.mobile")?.disable();
  //       this.form.get("company.name")?.setValue(this.selectedMember['DC Name English'] ?? '');
  //       this.form.get("company.email")?.setValue(this.selectedMember['Main Email Address'] ?? '');
  //       this.form.get("company.mobile")?.setValue(this.selectedMember['Main Phone Number'] ? Utils.parseMobile(this.selectedMember['Main Phone Number'], 'number') : '');
  //     }
  //   }
  //   this.form.patchValue({
  //     company: { countryCode: '971' },
  //     contact: { countryCode: '971' },
  //     representative: { countryCode: '971' },
  //     courier: { countryCode: '971' }
  //   });

  //   this.form.get('company.countryCode')?.disable();
  //   this.form.get('contact.countryCode')?.disable();
  //   this.form.get('representative.countryCode')?.disable();
  //   this.form.get('courier.countryCode')?.disable();
  // }
  // This method is used to set emirate license using value
  setEmirateLicense(value: any) {
    let companyFields = ['otherEmirateName'];
    this.toggleRequired(value == FieldValue.YES || value == FieldValue.YES_AR ? true : false, companyFields);
  }

  // This method is used to handle carnet type change event using value
  onCarnetTypeChange(value: string, isCallSubmit = false) {
    let fields = ['journeyDetails', 'journeyDestination', 'journeyEntryType', 'journeyTransportMode'];
    if (value == "regular") {
      this.journeyList = [];
    }
    let isJourneyRequired = (value == "regular" && this.journeyList.length < 1);
    this.toggleRequired(isJourneyRequired, fields);

    if (this.showActions && this.srCurrentStatus == ""
      || this.srCurrentStatus == SrStatus.Draft
      || this.srCurrentStatus == SrStatus.AwaitingClarification
      || this.srCurrentStatus == SrStatus.Open) {
      if (isCallSubmit) {
        this.saveAndGetDeposit();
      }
    }
  }

  // This method is used to handle change collection type event using value
  onChangeCollectionType(value: any) {
    let collectionTypeValue = "";
    if (value?.selectedLov?.Name) {
      collectionTypeValue = value?.selectedLov?.Name;
    } else {
      collectionTypeValue = value;
    }
    let fields = ['courier.mobile', 'courier.buildingUnit', 'courier.address', 'courier.area', 'courier.emirate'];
    this.toggleRequired(collectionTypeValue == FieldValue.COURIER_EN || collectionTypeValue == FieldValue.COURIER_AR ? true : false, fields);
  }

  // This method is used to view on map
  viewOnMap() {
    const address = 'Dubai Chambers, Baniyas Road, Deira, Dubai, UAE';
    const url = "https://maps.app.goo.gl/BA7659qiohqbDRNw6";
    try {
      window.open(url, '_blank');
    } catch {
      window.location.href = url;
    }
  }
  // This method is used to toggle required using condition and controls
  private toggleRequired(condition: boolean, controls: string[]): void {
    Utils.addRemoveValidation(this.form, condition, controls);
  }
  applicantTypes: any = [];
  // This method is used to get applicant type
  getApplicantType() {
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get List Of Values WF",
        "Type": LookupKey.DC_PORTAL_APPLICANT_TYPE,
        "LanguageCode": this.lang == 'ar' ? 'ARA' : 'ENU',
        "ParentValue": "",
        "Sub Type": ""
      }
    }
    this.api.post(
      ApiRoot.DCCICPIntegration, ApiEndPoints.LOOKUP_URL,
      requestPayload
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        if (response["Error Message"] == null && response.SiebelMessage?.["List Of Values"]) {
          this.applicantTypes = Utils.checkIsArray(response.SiebelMessage["List Of Values"]);

        }
        this.getProcessType();
      }
    })
  }

  processTypes: any = [];
  // This method is used to get process type
  getProcessType() {
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get List Of Values WF",
        "Type": LookupKey.ATA_PROCESSING_TYPE,
        "LanguageCode": this.lang == 'ar' ? 'ARA' : 'ENU',
        "ParentValue": "",
        "Sub Type": ""
      }
    }
    this.api.post(
      ApiRoot.DCCICPIntegration, ApiEndPoints.LOOKUP_URL,
      requestPayload
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        if (response["Error Message"] == null && response.SiebelMessage?.["List Of Values"]) {
          this.processTypes = Utils.checkIsArray(response.SiebelMessage["List Of Values"]);
        }
      }
    })
  }
  currencyList: any = [];
  // This method is used to get currency list
  getCurrencyList() {
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get Currency List WF",
        "CurrencyCode": ""
      }
    }
    this.api.post(
      ApiRoot.DCCICPIntegration, ApiEndPoints.GET_CURRENCY_LIST,
      requestPayload
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        if (response.SiebelMessage?.Currency) {
          let list = Utils.checkIsArray(response.SiebelMessage?.Currency);
          this.currencyList = list.map((item: any) => ({
            ...item,
            Name: item.Name,
            Value: item["Currency Code"]
          }));
        }
      }
    })
  }

  carnetNumberList: any = [];
  loadingCarnetList: boolean = false;
  // This method is used to get ata carnet list
  getATACarnetList() {
    this.loadingCarnetList = true;
    const request = new GetCarnetNoRequest();
    request.body.DCLoginName = this.userLoginName;
    request.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();
    let sr = request.body.DCIncomingHierarchy["ListOfDC Community Portal ATA SR IO"]["DC Community Portal ATA SR"];
    sr.CSN = this.userCSN;
    sr['SR Type'] = this.srType;
    sr['Sub Type'] = this.srSubType;

    this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.GET_ATA_CARNET_DETAILS,
      request
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        if ((response['Error Code'] == null || response['Error Code'] == "DC-VAL-ERR") && response["SiebelMessage"]?.["DC Community Portal ATA SR"]) {
          let result = Utils.checkIsArray(response["SiebelMessage"]["DC Community Portal ATA SR"]);

          const validCarnets = this.sharedService.getValidCarnetList(result);
          this.carnetNumberList = [...this.carnetNumberList, ...validCarnets];
          this.loadingCarnetList = false;
        } else {
          this.loadingCarnetList = false;
        }
      }, error: () => {
        this.loadingCarnetList = false;
      }
    })
  }

  expiredCarnetMsg: boolean = false;
  technicalErrorMsg: boolean = false;
  isCarnetValidityNull: boolean = false;
  // This method is used to handle carnet change event using option
  onCarnetChange(option: any) {
    this.expiredCarnetMsg = false;
    this.technicalErrorMsg = false;
    this.errorMsg = "";
    this.copyCarnetErrorMsg = "";
    this.isCarnetValidityNull = false;
    if (!option?.selectedLov) {
      return;
    }
    // Need to check the carnet validity
    const validityDateStr = option.selectedLov['DC ATA Carnet Validity Dt'];
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (!validityDateStr) {
      this.isCarnetValidityNull = true;
      this.technicalErrorMsg = true;
      return;
    }
    const validityDate = new Date(validityDateStr);
    validityDate.setHours(0, 0, 0, 0);
    if (isNaN(validityDate.getTime())) {
      this.expiredCarnetMsg = true;
      return;
    }

    if (validityDate < today) {
      this.expiredCarnetMsg = true;
      return;
    }

    let srNo = option?.selectedLov["SR Number"];
    if (this.srNumber && srNo) {
      this.loadingSrDetail = true;
      this.copyCarnetNoDataToSR();
    } else {
      if (srNo) {
        let formData = this.form.getRawValue();
        this.loadingSrDetail = true;
        this.submitSRData(formData, SrActionType.DRAFT, true);
      }
    }
  }
  copyCarnetErrorMsg: string = '';
  // This method is used to copy carnet no data to sr
  copyCarnetNoDataToSR() {
    this.technicalErrorMsg = false;
    this.copyCarnetErrorMsg = "";

    let selectedCarNetSrNo: any = this.carnetNumberList?.find((c: any) => c.Value === this.form.get("carnetNumber")?.value)?.["SR Number"];

    const copyCarnetReq = new CopyCarnetSrRequest();
    copyCarnetReq.body.DCLoginName = this.userLoginName;
    copyCarnetReq.body.DCToSRNumber = this.srNumber;
    copyCarnetReq.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();
    let dcPortal = copyCarnetReq.body.DCIncomingHierarchy["ListOfDC Community Portal SR Upsert IO"]["DC Community Portal SR"];
    dcPortal["SR Number"] = selectedCarNetSrNo;
    dcPortal.CSN = this.userCSN;
    dcPortal['SR Type'] = this.srType;
    dcPortal['Sub Type'] = this.srSubType;

    this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.ATA_MANAGE_SERVICE_REQUEST,
      copyCarnetReq
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        if ((response['Error Code'] == null || response['Error Code'] == "DC-VAL-ERR") && response['Error Message'] == null && response["SiebelMessage"]?.["DC Community Portal SR"]) {
          this.products = [];
          this.journeyList = [];
          this.getSRDetail();
        } else {
          this.loadingSrDetail = false;
          this.form.get("carnetNumber")?.setValue(null);
          if (response['Error Code'] == 'DC-VAL-ERR' && response["Error Message"] != null) {
            this.copyCarnetErrorMsg = response['Error Message'];
          } else {
            this.technicalErrorMsg = true;
          }
        }
      }
    })
  }

  // This method is used to move to the next step
  nextStep(): void {
    this.errorMsg = "";
    this.technicalErrorMsg = false;
    this.depositAmountError = false;
    if (this.isCarnetValidityNull || this.expiredCarnetMsg) {
      return;
    }
    const stepFieldsMap: { [key: number]: string[] } = {
      1: ['carnetNumber', 'hasOtherEmirateLicense', 'otherEmirateName', 'companNameEng', 'companNameAra'],
      2: [
        'contact.fullName',
        'contact.email',
        'contact.mobile',
        'contact.countryCode',
        'contact.phone'
      ],
      3: ['cargo.purpose', 'cargo.currency'],
      4: ['products'],
      5: ['carnetType', 'journeyDetails', 'journeyDestination', 'journeyEntryType', 'journeyTransportMode', 'journeyAddCounterfoils'],
      6: ['substituteReason', 'processingType', 'collectionType', 'courier.countryCode', 'courier.mobile', 'courier.email', 'courier.buildingUnit', 'courier.address', 'courier.area', 'courier.emirate', 'paymentMethod']
    };
    if (this.textFields && this.optionFields) {
      this.allFields = [...this.textFields.toArray(), ...this.optionFields.toArray(), ...this.mobileFields.toArray(), ...this.dateFields.toArray()];
    }

    if (this.step > 2) {
      this.isFromSumit = true;
    }
    if (!environment.ignoreValidators) {
      // Validate all steps up to the current step
      for (let i = 1; i <= this.step; i++) {
        const fieldsToCheck = stepFieldsMap[i] || [];
        if (Utils.handleInvalidStep(this.form, this.allFields, fieldsToCheck)) {
          const invalidControls = Utils.getInvalidControls(this.form);
          this.form.markAllAsTouched();
          this.invalidSummary = this.getInvalidFieldLabels();
          return;
        }
      }
    }

    // Clear any previous invalid summary when proceeding
    this.invalidSummary = [];
    const formData = this.form.getRawValue();

    if (this.step == 4 || this.step == 6) {
      if (this.srNumber == "" && this.isDraftInProgress == false) {
        this.submitSRData(formData, SrActionType.DRAFT);
      }
    }
    const invalidControls = Utils.getInvalidControls(this.form);
    if (this.step >= 7) {
      if (this.form.invalid && invalidControls) {
        this.form.markAllAsTouched();
        Utils.focusFirstInvalidControl(this.form, this.allFields);
        return;
      }

      if (this.form.invalid || this.checkRequiredDocuments() || this.noAdvancePaymentBalance) {
        this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
        return;
      }
      //for ATA amendmet we have to check the calculated security amount
      if (this.isAmendmentCarnet) {
        const approxSecurityAmt = parseFloat(this.securityAmount.toFixed(2));
        const availableAmt = parseFloat(this.availabelDepositAmount.toFixed(2));
        if (approxSecurityAmt > availableAmt) {
          this.depositAmountError = true;
          this.sharedService.toastMessage("ERROR", "ATA_DEPOSIT_INCREASE", 'error', true);
          return;
        }
      }
      this.openTermsModal();
      //this.submitSRData(formData, SrActionType.SUBMIT);
    }

    if (this.step < 7) {
      this.step++;
    }
  }
  // This method is used to preview form
  previewForm() {
    localStorage.setItem("application-data", JSON.stringify(this.form.value));
    let path = `/${RoutesPath.SERVICE}/ata-carnet-preview`;
    this.router.navigate([path]);
  }

  // Displayed subset of products
  visibleProducts: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 4;
  totalPages: number = 0;

  addNewProduct() {
    if (this.isAmendmentCarnet) {
      this.sharedService.toastMessage("ERROR", "ATA_DEPOSIT_INCREASE", 'error', true);
    }
    this.selectedProductMode = 'add';
    this.addProductModal = true;
    this.selectedProduct = '';
  }
  // This method is used to handle product submit event using new added products
  onProductSubmit(newProductObj: any) {
    if (newProductObj?.replaceAll) {
      this.products = newProductObj?.allProducts;
    } else {
      newProductObj?.allProducts?.forEach((newProduct: any) => {
        const index = this.products.findIndex(p => p.id === newProduct.id);
        if (index !== -1) {
          this.products[index] = { ...this.products[index], ...newProduct };
        } else {
          this.products.push(newProduct);
        }
      });
    }
    // Update pagination
    this.totalPages = Math.ceil(this.products.length / this.itemsPerPage);
    this.form.get("products")?.setValue(this.products.length > 0 ? "selected" : "");
    this.saveAndGetDeposit();
    if (this.totalPages < 2) {
      this.currentPage = 1;
    }
    this.loadPage(this.currentPage);
  }
  //Edit Product
  selectedProduct: any = ""
  selectedProductMode: string = "add";
  // This method is used to edit product using product
  editProduct(product: any, mode: string = "edit") {
    this.selectedProduct = product;
    this.selectedProductMode = mode;
    this.addProductModal = true;
  }

  // This method is used to load page using page
  loadPage(page: number): void {
    this.currentPage = page;
    const start = (page - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.visibleProducts = this.products.slice(start, end);
  }
  // This method is used to remove product using product to remove
  removeProduct(productToRemove: any): void {
    // Remove the product from the full list
    this.products = this.products.filter(p => p.id !== productToRemove.id);

    // Recalculate total pages
    this.totalPages = Math.ceil(this.products.length / this.itemsPerPage);

    // If current page is now empty, go back one page (if not on page 1)
    const currentStartIndex = (this.currentPage - 1) * this.itemsPerPage;
    if (this.products.length <= currentStartIndex && this.currentPage > 1) {
      this.currentPage--;
    }
    this.form.get("products")?.setValue(this.products.length > 0 ? "selected" : "");
    // Reload the visible products for the current page
    this.loadPage(this.currentPage);
    this.saveAndGetDeposit();
  }

  removeAllProducts() {
    this.products = [];
    this.form.get("products")?.setValue("");
    this.loadPage(this.currentPage);
    this.saveAndGetDeposit();
  }

  visitTransitErrorMsg: any = null;
  // This method is used to save journey detail using add another
  saveJourneyDetail(addAnother: boolean = false): void {
    if (
      !this.form.get('journeyDestination')?.value
      || !this.form.get('journeyEntryType')?.value
      || !this.form.get('journeyTransportMode')?.value
      || !this.form.get('visitCounterfoil')?.valid
      || !this.form.get('transitCounterfoil')?.valid
    ) {
      let fields = ['journeyDestination', 'journeyEntryType', 'journeyTransportMode'];
      this.toggleRequired(true, fields);

      this.form.markAllAsTouched();
      return;
    }
    const value = { ...this.form.value } as JourneyDetail;
    const country = this.form.get('journeyDestination')?.value;
    const visitTransit = this.form.get('journeyEntryType')?.value;

    this.visitTransitErrorMsg = this.checkCountryVisitTransit(country, visitTransit);
    if (this.visitTransitErrorMsg) {
      return;
    }
    if (this.editJourneyDetail !== null) {
      const index = this.journeyList.findIndex((j: any) => j.id === this.editJourneyDetail?.id);
      if (index !== -1) {
        this.journeyList[index] = this.createJourneyObject(value, index, this.editJourneyDetail?.id);
        this.journeyList = [...this.journeyList]; // <-- triggers change detection
      }
    } else {
      const jId: any = Utils.generateUniqueId();
      const newJourney = this.createJourneyObject(value, this.journeyList.length, jId);
      this.journeyList = [...this.journeyList, newJourney]; // also reassign here
    }

    this.form.get("journeyDetails")?.setValue(this.journeyList.length > 0 ? 'Added' : "");

    if (addAnother) {
      setTimeout(() => {
        this.form.get('journeyDestination')?.setValue(null);
        this.form.get('journeyEntryType')?.setValue(null);
        this.form.get('journeyTransportMode')?.setValue(null);
        this.form.get('visitCounterfoil')?.setValue('0');
        this.form.get('transitCounterfoil')?.setValue('0');
      }, 1000);
    } else {
      this.addJourney = false;
    }
    this.saveAndGetDeposit();
    this.editJourneyDetail = null;
  }

  // This method is used to check country visit transit using country and visit transit
  checkCountryVisitTransit(country: string, visitTransit: string): string | null {
    const countryTrimmed = country?.trim();
    const visitTypeTrimmed: string = visitTransit?.trim();

    // Rule 0: First country must be Visit (EN or AR)
    if (
      this.journeyList?.length === 0 &&
      !(visitTypeTrimmed === FieldValue.VISIT_EN || visitTypeTrimmed === FieldValue.VISIT_AR)
    ) {
      return 'first_country_not_visit';
    }

    // Rule 1: Visit or Transit Country should NOT be UAE
    if (
      ((visitTypeTrimmed === FieldValue.VISIT_EN ||
        visitTypeTrimmed === FieldValue.VISIT_AR ||
        visitTypeTrimmed === FieldValue.TRANSIT_EN ||
        visitTypeTrimmed === FieldValue.TRANSIT_AR) &&
        (countryTrimmed === FieldValue.UAE || countryTrimmed === FieldValue.UAE_AR))
    ) {
      return 'uae_visit';
    }

    // Rule 2: ReEntry Country MUST be UAE
    if (
      (visitTypeTrimmed === FieldValue.REENTRY_EN ||
        visitTypeTrimmed === FieldValue.REENTRY_AR) &&
      countryTrimmed !== FieldValue.UAE &&
      countryTrimmed !== FieldValue.UAE_AR
    ) {
      return 'uae_not_reEntry';
    }

    // Rule 3: Prevent duplicate combination inside journeyList
    const duplicateExists = this.journeyList?.some((journey: any) =>
      (journey?.id ?? null) !== (this.editJourneyDetail?.id ?? null) &&
      journey?.formFields?.journeyDestination?.trim() === countryTrimmed &&
      journey?.formFields?.journeyEntryType?.trim() === visitTypeTrimmed
    );

    if (duplicateExists) {
      return 'duplicate_combination';
    }
    return null;
  }

  // This method is used to add new journey
  addNewJourney() {
    if (this.isAmendmentCarnet) {
      this.sharedService.toastMessage("ERROR", "ATA_DEPOSIT_INCREASE", 'error', true);
    }
    this.editJourneyDetail = null;
    this.addJourney = true;
    this.form.get('journeyDestination')?.setValue(null);
    this.form.get('journeyEntryType')?.setValue(null);
    this.form.get('journeyTransportMode')?.setValue(null);
    this.form.get('visitCounterfoil')?.setValue('0');
    this.form.get('transitCounterfoil')?.setValue('0');
  }

  //cancel travel plan
  cancelTravelPlan() {
    if (this.journeyList.length > 0) {
      let fields = ['journeyDestination', 'journeyEntryType', 'journeyTransportMode'];
      this.toggleRequired(false, fields);
      this.form.markAllAsTouched();
      this.addJourney = false;
    }
  }

  // This method is used to create journey object using value, index, and id
  private createJourneyObject(value: {
    journeyDestination: string;
    journeyEntryType: string;
    journeyTransportMode: string;
    visitCounterfoil: string,
    transitCounterfoil: string,
    // reEntryCounterfoil: string
  }, index: number, id: any) {
    return {
      id: id,
      formFields: {
        journeyDestination: value.journeyDestination,
        journeyEntryType: value.journeyEntryType,
        journeyTransportMode: value.journeyTransportMode,
        visitCounterfoil: value.visitCounterfoil,
        transitCounterfoil: value.transitCounterfoil,
        //reEntryCounterfoil: value.reEntryCounterfoil,
      },
      fields: [
        { label: 'ATA_CARNET.DESTINATION', value: index + 1 },
        { label: 'ATA_CARNET.DEST_COUNTRY', value: value.journeyDestination },
        { label: 'ATA_CARNET.ENTRY_TYPE', value: value.journeyEntryType },
        { label: 'ATA_CARNET.MODE_OF_TRANSPORT', value: value.journeyTransportMode },
        // { label: 'ATA_CARNET.COUNTERFOLLIOS_REQUIRED', value: 0 },
        { label: 'ATA_CARNET.ADDITIONAL_VISIT_COUNTERFOIL', value: value.visitCounterfoil },
        { label: 'ATA_CARNET.ADDITIONAL_TRANSIT_COUNTERFOIL', value: value.transitCounterfoil },
        //{ label: 'ATA_CARNET.ADDITIONAL_REENTRY_COUNTERFOIL', value: value.reEntryCounterfoil }
      ]
    };
  }

  // This method is used to handle travel plan event event using event
  onTravelPlanEvent(event: any) {
    if (event.type == "edit") {
      this.editJourney(event.data);
    } else {
      this.deleteJourney(event.data.id);
    }
  }
  /**
   * Populate the form for editing the selected journey 
   * @param journey 
   */
  // This method is used to edit journey using journey
  editJourney(journey: any): void {
    if (this.isAmendmentCarnet) {
      this.sharedService.toastMessage("ERROR", "ATA_DEPOSIT_INCREASE", 'error', true);
    }
    if (journey) {
      this.form.patchValue({
        journeyDestination: journey.formFields.journeyDestination,
        journeyEntryType: journey.formFields.journeyEntryType,
        journeyTransportMode: journey.formFields.journeyTransportMode,
        journeyAddCounterfoils: journey.formFields.journeyAddCounterfoils ?? '',
        visitCounterfoil: journey.formFields.visitCounterfoil ?? '0',
        transitCounterfoil: journey.formFields.transitCounterfoil ?? '0'
      });
      this.editJourneyDetail = journey;
      this.addJourney = true;
    }
  }

  /**
   * Method for delete journey from travel plan list
   * @param jId 
   */
  // This method is used to delete journey using j id
  deleteJourney(jId: number): void {
    this.journeyList = this.journeyList.filter((j: any) => j.id !== jId);
    this.form.get("journeyDetails")?.setValue(this.journeyList.length > 0 ? 'Added' : "");
    if (this.journeyList.length < 1) {
      let fields = ['journeyDestination', 'journeyEntryType', 'journeyTransportMode'];
      this.toggleRequired(true, fields);
      this.form.markAllAsTouched();
      this.addNewJourney();
    }
    this.saveAndGetDeposit();
  }
  // This method is used to save and get deposit
  saveAndGetDeposit() {
    if (this.isReplaceCarnet || this.isSubstituteCarnet) {
      return;
    }
    // this.showDepositLoader = true;
    let formData = this.form.getRawValue();
    this.submitSRData(formData, SrActionType.DRAFT);

  }
  securityAmount: any = 0.00;
  showDepositLoader: boolean = false;
  // This method is used to get security deposit
  getSecurityDeposit() {
    //If replacecarnet and subsititue then no need to call get deposit amount 
    if (this.isReplaceCarnet || this.isSubstituteCarnet) {
      return;
    }
    this.showDepositLoader = true;
    this.securityDepositRequest.body.DCLoginName = this.userLoginName ? this.userLoginName : "PRAKASHPOOJARY";
    this.securityDepositRequest.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();

    const sr = this.securityDepositRequest.body.DCIncomingHierarchy["ListOfDC Community Portal SR IO"]["DC Community Portal SR"];
    sr["SR Number"] = this.srNumber;
    sr['SR Type'] = this.srType;
    sr["Sub Type"] = this.srSubType;
    sr["CSN"] = this.userCSN;

    this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.ATA_QUERY_SERVICEREQUEST,
      this.securityDepositRequest
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        if ((response['Error Code'] == null || response['Error Code'] == "DC-VAL-ERR") && response['Error Message'] == null) {
          this.showDepositLoader = false;
          this.securityAmount = response["DepositAmount"] != null ? response["DepositAmount"] : 0.00;

          if (this.isAmendmentCarnet) {
            const approxSecurityAmt = parseFloat(this.securityAmount.toFixed(2));
            const availableAmt = parseFloat(this.availabelDepositAmount.toFixed(2));
            if (approxSecurityAmt > availableAmt) {
              this.depositAmountError = true;
              this.sharedService.toastMessage("ERROR", "ATA_DEPOSIT_INCREASE", 'error', true);
            }
          }
        } else {
          this.showDepositLoader = false;
          this.securityAmount = 0.00;
          if (response['Error Code'] == 'DC-VAL-ERR' && response["Error Message"] != null) {
            this.errorMsg = response['Error Message'];
          } else {
            this.technicalErrorMsg = true;
          }
        }
      },
      // This method is used to handle the error callback using e
      error: (e) => {
        this.showDepositLoader = false;
        this.formSubmitLoader = false;
      }
    })
  }
  //get folder id and attachments
  srFolder!: FolderResponse;
  mainFromSectionDocs: AllowedDocumentType[] = [];

  // This method is used to open folder
  openFolder() {
    if (this.isSubstituteCarnet || this.isReplaceCarnet) {
      return;
    }
    this.loadingDoc = true;
    let isLabels = !this.srNumber; // true if srNumber is empty
    this.sharedService.getDocuments(this.srNumber, DocumentServiceType.ATA_CARNET, isLabels)
      .subscribe({
        // This method is used to handle the next callback using response
        next: (response: any) => {
          if (response.success == true) {
            this.srFolder = response.data ? response.data : response;
            if (this.srFolder?.allowedDocumentTypes && this.srFolder?.allowedDocumentTypes?.length > 0) {
              this.loadingDoc = false;
              this.mainFromSectionDocs = this.srFolder.allowedDocumentTypes?.filter((d: any) => !d.forUISection);
              this.updateDocumentMandatory();
            }
          } else {
            this.sharedService.toastMessage("error", response.message, 'error');
          }
        }
      });
  }
  updateDocumentMandatory() {
    if (this.selectedMember?.['Account Type Code'] == UserType.MEMBER) {

      this.mainFromSectionDocs = this.mainFromSectionDocs
        .filter(doc => !(doc.nameEn === 'Trade_License_Copy' && !this.isAmendmentCarnet));
    }
    if (this.isAmendmentCarnet) {
      this.mainFromSectionDocs = this.mainFromSectionDocs
        .filter(doc => !(doc.nameEn === 'Trade_License_Copy'));
    }
  }
  // This method is used to check required documents
  checkRequiredDocuments(): boolean {
    if (this.isSubstituteCarnet || this.isReplaceCarnet) {
      return false;
    }
    // If there are no docs to check, nothing is missing
    if (!this.mainFromSectionDocs || this.mainFromSectionDocs.length === 0) {
      return false;
    }
    const fileCmps = this.fileComponents && typeof this.fileComponents.toArray === 'function'
      ? this.fileComponents.toArray()
      : [];
    if (fileCmps.length < this.mainFromSectionDocs.length) {
      return false;
    }

    let hasMissing = false;
    for (let index = 0; index < this.mainFromSectionDocs.length; index++) {
      const doc = this.mainFromSectionDocs[index];
      const cmp = fileCmps[index];
      // Safety guard; should not happen due to length check above
      if (!cmp) continue;

      if (typeof cmp.checkMissing === 'function' && cmp.checkMissing((doc)?.mandatory)) {
        hasMissing = true;
      }
    }
    return hasMissing;
  }

  isFromSumit: boolean = false;
  formSubmitLoader: boolean = false;
  isSaved: boolean = false;
  successModal: boolean = false;
  showActions: boolean = true;
  loadingSrDetail: boolean = false;
  srCurrentStatus: string = "";
  private resolveSelectedMemberByCsn(csn: string) {
    if (!csn) {
      return null;
    }
    const accounts = Utils.checkIsArray(this.loginUserDetail?.Account) || [];
    return accounts.find((acc: any) => acc?.CSN === csn) || null;
  }
  // This method is used to get sr detail
  private getSRDetail() {
    this.loadingSrDetail = true;
    const queryReq = new CarnetQueryRequest();

    queryReq.body.DCLoginName = this.userLoginName;
    queryReq.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();
    let portalSr = queryReq.body.DCIncomingHierarchy["ListOfDC Community Portal SR IO"]["DC Community Portal SR"];
    portalSr["SR Number"] = this.srNumber;
    portalSr.CSN = this.userCSN || "";
    portalSr['SR Type'] = this.srType;
    portalSr['Sub Type'] = this.srSubType;

    this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.ATA_QUERY_SERVICEREQUEST,
      queryReq
    ).subscribe({
      next: (response: any) => {
        this.loadingSrDetail = false;
        if (response?.SiebelMessage && response?.SiebelMessage["DC Community Portal SR"]) {

          let srData = response?.SiebelMessage["DC Community Portal SR"];
          this.userCSN = srData?.["DC Member Num"] || this.userCSN;
          const matchedMember = this.resolveSelectedMemberByCsn(this.userCSN);
          if (matchedMember) {
            this.selectedMember = matchedMember;
          }
          if (!this.isNewCarnet && !this.carnetNumberList?.length && this.userCSN) {
            this.getATACarnetList();
            this.toggleRequired(true, ["carnetNumber"]);
          }

          // const isMyself = this.applicantTypes?.find((applicant: any) => applicant.Value == srData["DC ATA Applicant Type"])?.Name === "Myself";
          //srData["DC ATA Applicant Type"] === "Myself";
          //const carnetHolderType = isMyself ? "Myself" : "Other";
          //this.onHolderTypeChange(carnetHolderType);
          this.srCurrentStatus = srData["Status"];
          const carnetTypeValue = srData["DC Open Country"] === "Y" ? "open" : "regular";

          //this.onCarnetTypeChange(carnetTypeValue);

          // This method is used to get mobile info using mobile
          const getMobileInfo = (mobile?: string) => ({
            number: mobile ? Utils.parseMobile(mobile, "number") : "",
            cc: mobile ? (Utils.parseMobile(mobile, "cc") ? Utils.parseMobile(mobile, "cc") : "971") : "971"
          });

          const fields = {
            // holderType: carnetHolderType,
            carnetType: carnetTypeValue,
            processingType: srData?.["DC Processing Type"] ?? null,
            collectionType: srData?.["DC Collection Option"] ?? null,
            cargo: {
              purpose: srData?.["DC Intended Use Type"] ?? null,
              currency: srData?.["Currency"] ?? null
            },
            contact: {
              fullName: srData?.["DC Represented By"] ?? null,
              email: srData?.["DC Holder Email"] ?? null,
              mobile: getMobileInfo(srData?.["DC Holder Mobile"]).number,
              countryCode: getMobileInfo(srData?.["DC Holder Mobile"]).cc ?? '971',
              phone: srData?.["DC Holder Phone"] ?? null
            },
            hasOtherEmirateLicense: srData?.["DC ATA Company License Check"] == 'Y' ? (this.lang == 'en' ? FieldValue.YES : FieldValue.YES_AR) : (this.lang == 'en' ? FieldValue.NO : FieldValue.NO_AR),
            otherEmirateName: srData?.["DC ATA Company Emirate"] ?? null,
            companNameEng: srData?.["DC Member Name ENU"] ?? '',
            companNameAra: srData?.["DC Member Name ARA"] ?? '',
            courier: {
              buildingUnit: srData?.["DC Building Name"] ?? null,
              area: srData?.["DC Area"] ?? null,
              emirate: srData?.["DC Emirates"] ?? null,
              address: srData?.["DC Additional Consignee Address"] ?? null,
              email: srData?.["DC Courier Email Addr"] ?? "",
              mobile: getMobileInfo(srData?.["DC Courier Mobile"]).number,
              countryCode: getMobileInfo(srData?.["DC Courier Mobile"])?.cc ?? '971'
            },

            carnetNumber: srData?.["DC Carnet Number"] ?? null,
            substituteReason: srData?.["DC ATA Reason"] ?? null,
            paymentMethod: srData?.["DC Payment Method"] ?? null

          };
          this.form.patchValue(fields);
          const resProducts = srData?.["DC Community Portal Internal Product"] ?? null;
          const mappedProducts: any = resProducts?.map((p: any) => ({
            id: p['Id'],
            mode: "auto",
            search: "loaded",
            country: p["DC Country of Origin"] || "",
            unit: p["DC Unit of Measure"] || "",
            quantity: String(p["DC Quantity"] ?? "0"),
            bulkFile: null,
            productHSCode: p["DC HS Code"] ?? null,
            productNameEn: p["DC Product English Name"] || "",
            productNameAr: p["DC Product Arabic Name"] || "",
            unitPrice: String(p["DC Unit Price"] ?? "0"),
            category: p["DC Category Desc"] ?? p["DC Category Des LIC"],
            weight: String(p["DC Weight"] ?? "0")
          }));
          if (mappedProducts) {
            this.products = [...this.products, ...mappedProducts];
          }
          // Update pagination
          this.totalPages = Math.ceil(this.products.length / this.itemsPerPage);
          this.form.get("products")?.setValue(this.products.length > 0 ? "selected" : "");
          this.loadPage(this.currentPage);

          if (srData["DC Open Country"] != "Y") { //If regular carnet then add travel plans
            const srTravelPlans: any = srData?.["DC Community Portal Travel Plans"] ?? null;
            srTravelPlans?.map((t: any, index: number) => {
              let jId: any = Utils.generateUniqueId();
              let jObject = {
                journeyDestination: t["DC Travel Country"] || "",
                journeyEntryType: t["DC Visit Transit"] || "",
                journeyTransportMode: t["DC Transport Means"] || "",
                visitCounterfoil: t["DC Additional Cfoil"] || "0",
                transitCounterfoil: t["DC Additional Vchor"] || "0"
                //reEntryCounterfoil: "0"
              }
              const newJourney = this.createJourneyObject(jObject, index, jId);
              this.journeyList.push(newJourney);
            })

            if (this.journeyList.length > 0) {
              this.addJourney = false;
            }
            this.form.get("journeyDetails")?.setValue(this.journeyList.length > 0 ? 'Added' : "");
          }

          //set field validation for the journey details
          let travelPlanFields = ['journeyDetails', 'journeyDestination', 'journeyEntryType', 'journeyTransportMode'];
          let isJourneyRequired = (carnetTypeValue == "regular" && this.journeyList.length < 1);
          this.toggleRequired(isJourneyRequired, travelPlanFields);

          if ((fields.contact.fullName && fields.contact.mobile)) {
            this.step = 3
          }
          if (fields.cargo.purpose && fields.cargo.currency) {
            this.step = 4
          }
          if (this.products && this.products.length > 0) {
            this.step = 5
          }
          if ((this.journeyList && this.journeyList.length > 0) || srData["DC Open Country"] == "Y") {
            this.step = 6;
          }
          if (fields.processingType != "" && fields.carnetType != "") {
            this.step = 7;
          }
          this.availabelDepositAmount = srData['DC ATA Par Sec Dep Amt'] || 0;

          if (this.sharedService.enableNotesOption(srData["Status"])) {
            this.srInprgoressAwating = true;
            this.showNotes = true;
          }

          if (srData["Status"] != SrStatus.Draft && srData["Status"] != SrStatus.AwaitingClarification && srData["Status"] != SrStatus.Open) {
            this.showActions = false;
            this.form.disable();
            this.form.get("agree")?.setValue(true);
          }
          if (!this.isSubstituteCarnet && !this.isReplaceCarnet) {
            this.openFolder();
          }
          // get deposit amount
          if (carnetTypeValue == "open" && (this.products && this.products.length > 0)) {
            this.getSecurityDeposit();
          } else {
            if ((this.journeyList && this.journeyList.length > 0)
              && (this.products && this.products.length > 0)) {
              this.getSecurityDeposit();
            }
          }
        } else {
          if (response['Error Code'] == 'DC-VAL-ERR' && response["Error Message"] != null) {
            this.errorMsg = response['Error Message'];
          } else {
            this.technicalErrorMsg = true;
          }
        }
      },
      error: () => {
        this.loadingSrDetail = false
      }
    })
  }

  // This method is used to save and close
  saveAndClose(): void {
    const invalidControls = Utils.getInvalidControls(this.form);
    console.warn('Invalid controls:', invalidControls);
    const formFieldData = this.form.getRawValue();
    this.submitSRData(formFieldData, SrActionType.SAVE);
  }
  errorMsg: string = "";
  depositAmountError: boolean = false;
  isDraftInProgress: boolean = false;
  // This method is used to submit sr data using form data, action type, and is carnet no changed
  private submitSRData(formData: any, actionType: string, isCarnetNoChanged = false) {
    this.depositAmountError = false;
    this.errorMsg = "";
    this.technicalErrorMsg = false;
    let isActionSubmit = actionType == SrActionType.SUBMIT;
    let isActionSave = actionType == SrActionType.SAVE;
    let isActionDraft = actionType == SrActionType.DRAFT;

    if (Utils.hasMaxLengthError(this.form)) {
      this.form.markAllAsTouched();
      return;
    }

    //Prevent duplicate DRAFT call before SR number is created
    if (isActionDraft && !this.srNumber) {
      if (this.isDraftInProgress) {
        console.warn("Duplicate draft call prevented. SR number not generated yet.");
        return;
      }
      // First time -> allow and mark as in-progress
      this.isDraftInProgress = true;
    }

    if (isActionSubmit && (this.form.invalid || this.checkRequiredDocuments() || this.noAdvancePaymentBalance || this.loadingDoc)) {
      this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
      return;
    }

    this.request.body.DCMethod = isActionSubmit ? "SUBMIT" : "SAVEASDRAFT";
    this.request.body.DCLoginName = this.userLoginName ? this.userLoginName : "PRAKASHPOOJARY";
    this.request.body.DCLanguage = this.lang == 'ar' ? 'ARA' : 'ENU';
    this.request.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();

    let isLicenseCheck = formData?.hasOtherEmirateLicense ? (formData?.hasOtherEmirateLicense == FieldValue.YES || formData?.hasOtherEmirateLicense == FieldValue.YES_AR ? 'Y' : 'N') : 'N';

    const sr = this.request.body.DCIncomingHierarchy["ListOfDC Community Portal SR Upsert IO"]["DC Community Portal SR"];
    sr.CSN = this.userCSN;
    sr['SR Number'] = this.srNumber || "";
    sr['SR Type'] = this.srType;
    sr['Sub Type'] = this.srSubType;

    sr['DC Processing Type'] = formData?.processingType ? formData?.processingType : (this.lang == 'en' ? FieldValue.PROCESSING_TYPE_NORMAL : FieldValue.PROCESSING_TYPE_NORMAL_AR);
    sr['DC Collection Option'] = formData?.collectionType || '';
    sr['DC Open Country'] = isCarnetNoChanged ? "" : (formData?.carnetType == "open" ? "Y" : "N"); // N/Y

    sr['DC Represented By'] = formData?.contact?.fullName || '';
    sr['DC Holder Phone'] = formData?.contact?.phone || '';
    sr['DC Holder Mobile'] = formData?.contact?.mobile ? `${formData?.contact?.countryCode}${formData?.contact?.mobile}` : '';
    sr['DC Holder Email'] = formData?.contact?.email || '';

    sr['Currency'] = formData?.cargo?.currency || '';
    sr['DC Intended Use Type'] = formData?.cargo?.purpose || '';
    sr['DC Additional Detail'] = "";


    sr["DC Building Name"] = formData?.courier?.buildingUnit || '';
    sr["DC Area"] = formData?.courier?.area || '';
    sr["DC Emirates"] = formData?.courier?.emirate || '';
    sr["DC Additional Consignee Address"] = formData?.courier?.address || '';
    sr["DC Courier Email Addr"] = formData?.courier?.email || '';
    sr['DC Courier Mobile'] = formData?.courier?.mobile ? `${formData?.courier?.countryCode || '971'}${formData?.courier?.mobile}` : '';


    if (isCarnetNoChanged == false) {
      sr["DC Carnet Number"] = isCarnetNoChanged == false ? formData?.carnetNumber : '';
    }
    sr["DC Holder Mobile"] = formData?.contact?.mobile ? `${formData?.contact?.countryCode || '971'}${formData?.contact?.mobile}` : '';
    sr["DC Holder Email"] = formData?.contact?.email || '';
    sr['DC Channel'] = this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN;
    sr['DC Payment Method'] = formData?.paymentMethod || '';

    sr["DC ATA Consent"] = "Y";
    sr["DC ATA Pledged Letter Consent"] = "Y";
    sr["DC Bank Detail Consent"] = "N";
    sr["DC ATA Company License Check"] = isLicenseCheck;
    sr["DC ATA Company Emirate"] = formData?.otherEmirateName || '';
    sr["DC Member Name ENU"] = formData.companNameEng || '';
    sr["DC Member Name ARA"] = formData.companNameAra || '';
    // Add Products
    let products: any = this.products.map((p) => ({
      "Id": p.id,
      "DC HS Code": p.productHSCode ?? "",
      "DC Product English Name": p.productNameEn || "",
      "DC Product Arabic Name": p.productNameAr || "",
      "DC Country of Origin": p.country || "",
      "DC Unit of Measure": p.unit || "",
      "DC Unit Price": p.unitPrice || "0",
      "DC Quantity": p.quantity || "0",
      "DC Weight": p.weight || "0",
      //"DC Process Type": "",
      //"DC Processing Country": "",
      "DC Category Desc": p.category ?? ""
    }));
    sr["ListOfDC Community Portal Internal Product"]["DC Community Portal Internal Product"] = products?.length > 0 ? products : null;

    // Add Notes
    sr["ListOfDC Community Portal SR Notes"]["DC Community Portal SR Notes"] = null;

    // Add Travel Plans
    if (formData?.carnetType == "regular") {
      let travelPlans: any = this.journeyList.map((t: any) => ({
        "DC Visit Transit": t.formFields.journeyEntryType || "",
        "DC Travel Country": t.formFields.journeyDestination || "",
        "DC Travel Start Date": "",
        "DC Travel End Date": "",
        "DC Transport Means": t.formFields.journeyTransportMode || "",
        //"DC Intended Use": "",
        "DC Additional Vchor": t.formFields.transitCounterfoil || "0",
        "DC Additional Cfoil": t.formFields.visitCounterfoil || "0"
      }))
      sr["ListOfDC Community Portal Travel Plans"]["DC Community Portal Travel Plans"] = travelPlans?.length > 0 ? travelPlans : null;
    } else {
      //open carnet with three static country
      if (formData?.carnetType) {
        sr["ListOfDC Community Portal Travel Plans"]["DC Community Portal Travel Plans"] = isCarnetNoChanged ? null : this.lang == 'ar' ? OPEN_TRAVEL_PLANS_AR : OPEN_TRAVEL_PLANS;
      } else {
        sr["ListOfDC Community Portal Travel Plans"]["DC Community Portal Travel Plans"] = isCarnetNoChanged ? null : null;
      }
    }
    if (!isActionDraft) {
      this.formSubmitLoader = true;
      this.showActions = false;
    }
    if (isActionSubmit && this.expiredCarnetMsg) {
      return;
    }

    // update request based on srSub type
    let replaceReq: any = "";
    if (this.isReplaceCarnet || this.isSubstituteCarnet) {
      replaceReq = new AtaReplaceSRRequest();

      replaceReq.body.DCMethod = isActionSubmit ? "SUBMIT" : "SAVEASDRAFT";
      replaceReq.body.DCLoginName = this.userLoginName ? this.userLoginName : "";
      replaceReq.body.DCLanguage = this.lang == 'ar' ? 'ARA' : 'ENU';
      replaceReq.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();

      const sr = replaceReq.body.DCIncomingHierarchy["ListOfDC Community Portal SR Upsert IO"]["DC Community Portal SR"];
      sr["CSN"] = this.userCSN;
      sr['SR Number'] = this.srNumber || "";
      sr['SR Type'] = this.srType;
      sr['Sub Type'] = this.srSubType;

      sr['DC Processing Type'] = formData?.processingType ? formData?.processingType : ''; //'Normal'
      sr['DC Collection Option'] = formData?.collectionType || '';

      sr["DC Building Name"] = formData?.courier?.buildingUnit || '';
      sr["DC Area"] = formData?.courier?.area || '';
      sr["DC Emirates"] = formData?.courier?.emirate || '';
      sr["DC Additional Consignee Address"] = formData?.courier?.address || '';
      sr["DC Courier Email Addr"] = formData?.courier?.email || '';
      sr['DC Courier Mobile'] = formData?.courier?.mobile ? `${formData?.courier?.countryCode}${formData?.courier?.mobile}` : '';


      if (isCarnetNoChanged == false) {
        sr["DC Carnet Number"] = isCarnetNoChanged == false ? formData?.carnetNumber : '';
      }
      sr["DC ATA Reason"] = formData?.substituteReason || '';
      sr['DC Channel'] = this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN;

      sr["DC ATA Consent"] = "Y";
      sr["DC ATA Pledged Letter Consent"] = "Y";
      sr["DC Bank Detail Consent"] = "N";
      sr["DC ATA Company License Check"] = isLicenseCheck;
      sr["DC ATA Company Emirate"] = formData?.otherEmirateName || '';
      sr['DC Payment Method'] = formData?.paymentMethod || '';
      sr["DC Member Name ENU"] = formData.companNameEng || '';
      sr["DC Member Name ARA"] = formData.companNameAra || '';

    }
    this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.ATA_MANAGE_SERVICE_REQUEST,
      (this.isReplaceCarnet || this.isSubstituteCarnet) ? replaceReq : this.request
    ).subscribe({
      next: (response: any) => {
        if ((response['Error Code'] == null || response['Error Code'] == "DC-VAL-ERR") && response["DCSRNumber"] && response["Error Message"] == null || response["Error Message"] == "") {
          this.isSaved = true;
          if (isActionSave || isActionDraft) {
            if (isActionDraft && this.srNumber == "") {
              this.srNumber = response["DCSRNumber"];
              sessionStorage.setItem("srNumber", response["DCSRNumber"]);
              if (isCarnetNoChanged) {
                this.copyCarnetNoDataToSR();
              }
              this.openFolder();
            } else {
              this.srNumber = response["DCSRNumber"];
              if (isActionSave) {
                this.successModal = true;
              }
            }
            this.isDraftInProgress = false;
            if (!isCarnetNoChanged) {
              // Call get deposit amount if atleast one journey and product added
              if (formData?.carnetType != "regular" && (this.products && this.products.length > 0)) {
                this.getSecurityDeposit();
              } else {
                if ((this.journeyList && this.journeyList.length > 0)
                  && (this.products && this.products.length > 0)) {
                  this.getSecurityDeposit();
                }
              }
            }
          } else {
            this.srNumber = response["DCSRNumber"];
            //set sr detail for success page to get ioname
            const { service, serviceAr } = Utils.getServiceLabels(this.srSubType, this.lang);
            let srDetailObj = {
              mainService: this.srType,
              service: this.srSubType,
              serviceSubTypeEn: service,
              serviceSubTypeAr: serviceAr,
              IOName: SrIOName.ISSUE_NEW_ATA_CARNET,
              srNumber: this.srNumber,
              totalSteps: this.totalSteps,
              step: this.step + 1,
              feesAmount: response?.DCTotalFees ? response.DCTotalFees : '',
              memberCSN: this.userCSN
            }
            this.sharedService.setSrResponse(srDetailObj);

            this.sharedService.toastMessage('SUCCESS', 'REQUEST_SUBMITTED', 'success');
            sessionStorage.removeItem("srNumber");
            this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.SUCCESS_PAGE + "/" + this.srNumber}`]);
          }
          this.formSubmitLoader = false;
          this.showActions = true;
        } else {
          this.showActions = true;
          this.formSubmitLoader = false;
          if (response['Error Code'] == 'DC-VAL-ERR' && response["Error Message"] != null) {
            this.errorMsg = response['Error Message'];
          } else {
            this.technicalErrorMsg = true;
          }
        }
      },
      error: (e) => {
        this.showActions = true;
        this.formSubmitLoader = false;
        this.technicalErrorMsg = true;
      }
    })
  }

  // This method is used to close success modal
  closeSuccessModal() {
    this.successModal = false;
    sessionStorage.removeItem("srNumber");
    this.router.navigate([RoutesPath.DASHBOARD]);
  }
  // This method is used to open terms condition
  isTermsCondition: boolean = false
  openTermsCondition() {
    this.isTermsCondition = true;
    const formData = this.form.getRawValue();
    this.submitSRData(formData, SrActionType.DRAFT);

    let url = `${RoutesPath.SERVICE}/${RoutesPath.ATA.TERMS}`
    this.router.navigate([url]);
  }

  // This method is used to handel file event using document and document field
  handelFileEvent(document: any, documentField: any) {
    if (document?.documentId && document?.documentType == "Payment Slip Proof") {
      this.sendNotificationToFinance(document)
    }
  }

  // This method is used to validation message key
  get validationMessageKey(): string {
    switch (this.visitTransitErrorMsg) {
      case 'uae_visit':
        return 'ALERT.UAE_VISIT';
      case 'uae_not_reEntry':
        return 'ALERT.UAE_NOT_RENTRY';
      case 'first_country_not_visit':
        return 'ALERT.FIRST_COUNTRY_NOT_VISIT';
      case 'duplicate_combination':
        return 'ALERT.DUPLICATE_DESTINATION_ENTRY';
      default:
        return '';
    }
  }

  // Function for get all hs codes for validate on file upload
  totalHsRecords: number = 0;
  hsCodeRowNum: number = 0;
  masterHSCodeList: any = [];
  async getMasterHsCode(): Promise<[]> {
    let pageSize: any = 3000;
    this.hsCodeRowNum = 0;
    this.masterHSCodeList = [];

    const product = this.hsCodeRequest.body.IncomingHierarchy.ListOfDCHSCODELIST.PRODUCT;
    product.ProductCode = '';
    product.Description = '';

    do {
      this.hsCodeRequest.body.IncomingHierarchy.MessageId = Utils.generateUniqueId();
      this.hsCodeRequest.body.StartRowNum = this.hsCodeRowNum;
      this.hsCodeRequest.body.PageSize = pageSize;
      this.hsCodeRequest.body.NewQuery = this.hsCodeRowNum === 0 ? 'true' : 'false';
      this.hsCodeRequest.body.DCLanguage = this.lang == 'ar' ? 'ARA' : 'ENU';

      const response: any = await lastValueFrom(
        this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.GET_HS_CODE, this.hsCodeRequest)
      );

      if (response?.SiebelMessage && response?.SiebelMessage['PRODUCT']) {
        this.totalHsRecords = response.TotalRecords;
        let hsProducts = Utils.checkIsArray(response?.SiebelMessage['PRODUCT']);

        const mappedProducts = hsProducts.map(
          (hs, index) => ({
            id: this.hsCodeRowNum + index + 1,
            code: hs.ProductCode,
            name: hs.Description,
            description: hs.ProductNameARA,
          })
        );
        this.masterHSCodeList = [...this.masterHSCodeList, ...mappedProducts];
      }

      this.hsCodeRowNum += pageSize;
    } while (this.hsCodeRowNum < this.totalHsRecords);
    return this.masterHSCodeList;
  }

  termsModal = false;
  consentModalData: any;
  // This method is used to open terms modal
  openTermsModal() {
    this.consentModalData = {
      SRSubType: this.srSubType,
      companyName: this.form.getRawValue().contact.fullName,
      language: this.lang,
      reasonOrPurpose: this.form.getRawValue().substituteReason ? this.form.getRawValue().substituteReason : '',
      srNumber: this.form.value.srNumber ? this.form.value.srNumber : ''
    }
    this.termsModal = true;
  }

  // This method is used to submit pledge using value
  submitPledge(value: any) {
    this.termsModal = false;
    if (value == true) {
      const formData = this.form.getRawValue();
      this.submitSRData(formData, SrActionType.SUBMIT);
    }
  }

  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void {
    if (!this.isTermsCondition) {
      sessionStorage.removeItem("srNumber");
    }
  }

  // This method is used to determine if deactivate
  canDeactivate(): boolean {
    return this.sharedService.confirmNavigationIfFormDirty(this.form, this.isSaved);
  }

  // This method is used to send email after upload payment slip
  sendNotificationToFinance(document: any) {
    if (document?.documentId && document.documentType == "Payment Slip Proof") {
      const formData = this.form.getRawValue();
      let requestPayload = {
        "body": {
          "ProcessName": "DC Community Portal Generic Email Azure WF",
          "DCMethod": "ATA_PAYMENT_SLIP_PROOF",
          "DCLoginName": this.userLoginName ? this.userLoginName : "",
          "DCLanguage": this.lang == 'ar' ? 'ARA' : 'ENU',
          "MessageId": Utils.generateUniqueId(),
          "DCSRNumber": this.srNumber,
          "DCCommunicationTemplate": "DC ATA Payment Proof Notify Mail",
          "DCEmailAddress": ""
        }
      }
      this.api.post(
        ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
        ApiEndPoints.ATA_MANAGE_SERVICE_REQUEST,
        requestPayload
      ).subscribe({
        next: (response: any) => {
          if ((response['Error Code'] == null || response['Error Code'] == "DC-VAL-ERR") && response["DCSRNumber"] && response["Error Message"] == null || response["Error Message"] == "") {
            this.isSaved = true;
          } else {
            // if (response['Error Code'] == 'DC-VAL-ERR' && response["Error Message"] != null) {
            //   this.errorMsg = response['Error Message'];
            // } else {
            //   this.technicalErrorMsg = true;
            // }
          }
        }
      })
    }
  }

  // This method is used to handle payment method change event using option
  noAdvancePaymentBalance: boolean = false;
  onPaymentMethodChange(value: any) {
    this.noAdvancePaymentBalance = false;
    const selectedValue = value;
    if (selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES || selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES_AR) {
      this.noAdvancePaymentBalance = !this.sharedService.hasSufficientAdvanceForServicesBalance();
    } else {
      this.noAdvancePaymentBalance = false;
    }
  }

}
export interface JourneyDetail {
  journeyDestination: string;
  journeyEntryType: string;
  journeyTransportMode: string;
  journeyAddCounterfoils?: string | null;
  visitCounterfoil: string,
  transitCounterfoil: string
  // reEntryCounterfoil: string
}





